import { render, staticRenderFns } from "./ChampsDemission.vue?vue&type=template&id=6408d38a"
import script from "./ChampsDemission.vue?vue&type=script&lang=js"
export * from "./ChampsDemission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports